<template>
	<v-dialog
		v-model="dialog"
		scrollable
		max-width="700"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		@click:outside="closeDialog"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="'primary'"
				class="ml-2 template-btn"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				テンプレート作成
			</v-btn>
		</template>
		<v-card :tile="$vuetify.breakpoint.xs" height="100%">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">テンプレート作成</v-app-bar-title>
				<v-spacer />

				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<ValidationError :errors="errors" />
			<v-form ref="form" v-model="isValid">
				<v-container>
					<v-text-field
						v-model.trim="name"
						:rules="[rules.required]"
						class="mt-4"
						label="テンプレート名(必須)"
						hint="メッセージ作成時に選択するテンプレート名"
						outlined
						dense
					></v-text-field>
					<v-textarea
						v-model="fixedFormSentences"
						:rules="[rules.required]"
						class="mt-4"
						label="テンプレート文章(必須)"
						hint="メッセージ作成時に表示される内容"
						outlined
						dense
					></v-textarea>
				</v-container>

				<v-card-actions class="pa-0">
					<v-row no-gutters class="my-4" justify="center">
						<v-btn
							class="ma-1 white--text font-weight-bold"
							@click="createMessageTemplate"
							:disabled="!isValid"
							dense
							color="secondary"
						>
							<v-icon class="mr-1">mdi-plus</v-icon>
							作成する</v-btn
						>
					</v-row>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import rules from "../../../helper/rules"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import ValidationError from "../../shared/ValidationError.vue"

export default {
	props: {
		text: Boolean,
	},
	components: {
		ValidationError,
	},
	data() {
		return {
			rules,
			errors: [],
			name: "",
			fixedFormSentences: "",
			dialog: false,
			isValid: false,
		}
	},
	methods: {
		closeDialog() {
			this.dialog = false
			this.errors = []
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
		resetForm() {
			this.$refs.form.reset()
		},
		createMessageTemplate() {
			const headers = authenticate.setHeader()
			axios
				.post(
					"/erp/v1/message_templates",
					{
						message_template: {
							name: this.name,
							fixed_form_sentences: this.fixedFormSentences,
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "テンプレートを作成しました。",
					})
					this.resetForm()
					this.dialog = false
					this.errors = []
					this.$emit("new-message-template", res.data.message_template)
				})
				.catch((err) => {
					if (err.response?.status == 400) {
						this.errors = err.response.data
					}
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.template-btn {
	@media (max-width: 426px) {
		margin-top: 5px;
	}
}
</style>
